import styled from "styled-components";

const Wrapper = styled.div`
  height: 2vh;
`;

const NewsSpacer = (props: { children?: any; source?: string }) => {
  return <Wrapper>{props.children}</Wrapper>;
};

export default NewsSpacer;
